// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registration_button {
  padding: 10px 15px;
  margin-left: 10px;
  border-radius: 5px;
  border: none;
  outline: none;
  color: white;
  background: #06b6d4;
  cursor: pointer;
}
.registration_container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Registration/Registration.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV","sourcesContent":[".registration_button {\n  padding: 10px 15px;\n  margin-left: 10px;\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  color: white;\n  background: #06b6d4;\n  cursor: pointer;\n}\n.registration_container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
